import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TypographyStyledGlobal, fontWeight, colors, fontSize } from '../../../theme';
import ExportType from '../../../utils/enum/ExportType';
import ExportDropdown from '../../Dashboard/ExportDropdown/exportDropdown';
import LineChartModal from '../../Modals/ChartsModal/LineChartModal';
import { SummaryBoxProps } from '../hotAlertsInterface';
import { SummaryBoxStyled, SummaryElementStyled, HotAlertHistoricButtonStyled, SummaryGroupStyled } from './styled';
import { ReactComponent as HistoricalImage } from '../../../assets/charts/historical.svg';

const SummaryBox: FC<SummaryBoxProps> = ({ displayExport, hasStatus, numberOfhotAlerts, hotAlertCounts, surveyId, historical, selectedScope, selectedDateRange, historicalTemporalityOptions, selectedHistoricalTemporality, handleChangeHistoricalTemporality }) => {
    const { t } = useTranslation('hotAlerts');
    const [openHistoricalModal, setOpenHistoricalModal] = useState<boolean>(false);

    const handleCloseHistoricalModal = () => {
        setOpenHistoricalModal(false);
    };

    return (
        <SummaryBoxStyled>
            <SummaryGroupStyled style={{ margin: 'auto' }}>
                <SummaryElementStyled>
                    <TypographyStyledGlobal
                        color={colors.grey200}
                        margin='0'
                        size={fontSize.xxl}
                        sx={{ lineHeight: '24px' }}
                        weight={fontWeight.bold}
                    >
                        {numberOfhotAlerts}
                    </TypographyStyledGlobal>
                    <TypographyStyledGlobal
                        color={colors.grey200}
                        margin='0'
                        size={fontSize.m}
                        sx={{ lineHeight: '24px' }}
                        weight={fontWeight.semiRegular}
                    >
                        {t('summary.countedHotAlerts')}
                    </TypographyStyledGlobal>
                </SummaryElementStyled>
                {hasStatus && (
                    <>
                        <SummaryElementStyled>
                            <TypographyStyledGlobal
                                color={colors.default2}
                                margin='0'
                                size={fontSize.xxl}
                                sx={{ lineHeight: '24px' }}
                                weight={fontWeight.bold}
                            >
                                {hotAlertCounts.numberToTreat}
                            </TypographyStyledGlobal>
                            <TypographyStyledGlobal
                                color={colors.grey200}
                                margin='0'
                                size={fontSize.m}
                                sx={{ lineHeight: '24px' }}
                                weight={fontWeight.semiRegular}
                            >
                                {t('summary.toTreatHotAlerts')}
                            </TypographyStyledGlobal>
                        </SummaryElementStyled>
                        <SummaryElementStyled>
                            <TypographyStyledGlobal
                                color={colors.grey200}
                                margin='0'
                                size={fontSize.xxl}
                                sx={{ lineHeight: '24px' }}
                                weight={fontWeight.bold}
                            >
                                {hotAlertCounts.numberOfClosed}
                            </TypographyStyledGlobal>
                            <TypographyStyledGlobal
                                color={colors.grey200}
                                margin='0'
                                size={fontSize.m}
                                sx={{ lineHeight: '24px' }}
                                weight={fontWeight.semiRegular}
                            >
                                {t('summary.closedHotAlerts')}
                            </TypographyStyledGlobal>
                        </SummaryElementStyled>
                    </>
                )}
            </SummaryGroupStyled>
            <SummaryGroupStyled>
                <SummaryElementStyled>
                    <HotAlertHistoricButtonStyled bgColor={colors.default} bgColorHover={colors.defaultHover} fontColor='white' onClick={() => setOpenHistoricalModal(true)} boxShadow>
                        <HistoricalImage height={25} width={25} />
                        <TypographyStyledGlobal
                            margin='0px'
                            weight={fontWeight.regular}
                        >
                            {t('summary.historical')}
                        </TypographyStyledGlobal>
                    </HotAlertHistoricButtonStyled>
                </SummaryElementStyled>
                {displayExport && (
                    <SummaryElementStyled>
                        <ExportDropdown exportCase={ExportType.HOT_ALERTS} exportPdf={false} horizontal='left' selectedClauseFilter={[]} selectedDateRange={selectedDateRange} selectedScope={selectedScope} surveyId={surveyId} vertical='bottom' />
                    </SummaryElementStyled>
                )}
                <LineChartModal
                    handleChangeTemporality={handleChangeHistoricalTemporality}
                    handleClose={handleCloseHistoricalModal}
                    historical={historical}
                    openModal={openHistoricalModal}
                    selectedTemporality={selectedHistoricalTemporality}
                    temporalityOptions={historicalTemporalityOptions}
                    title={t('summary.linechartTitle')}
                />
            </SummaryGroupStyled>
        </SummaryBoxStyled>
    );
};

export default SummaryBox;
